import { indent, outdent } from '@platejs/indent';
import { IndentPlugin } from '@platejs/indent/react';
import { KEYS } from 'platejs';
import { useEditorState } from 'platejs/react';
import { type MouseEvent } from 'react';

import IndentIcon from '../../../../../icons/indent.svg?react';
import OutdentIcon from '../../../../../icons/outdent.svg?react';
import { ToolbarButton } from '../../ToolbarButton';

export const indentPlugin = IndentPlugin.configure({
  inject: { targetPlugins: [KEYS.p] },
  options: { offset: 24 },
});

export const IndentToolbarButtons = ({
  indentLabel = 'Indent',
  outdentLabel = 'Outdent',
}: {
  indentLabel?: string;
  outdentLabel?: string;
}) => {
  const editor = useEditorState();

  return (
    <>
      <ToolbarButton
        tooltip={outdentLabel}
        onClick={(event: MouseEvent<HTMLButtonElement>) => {
          event.preventDefault();
          event.stopPropagation();
          outdent(editor);
          editor.tf.focus();
        }}
      >
        <OutdentIcon />
      </ToolbarButton>
      <ToolbarButton
        tooltip={indentLabel}
        onClick={(event: MouseEvent<HTMLButtonElement>) => {
          event.preventDefault();
          event.stopPropagation();
          indent(editor);
          editor.tf.focus();
        }}
      >
        <IndentIcon />
      </ToolbarButton>
    </>
  );
};
